import { ModalTransition } from '@atlaskit/modal-dialog';
import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { INSTALLED_STATE_CONTENT } from '../AppRequestDialog.constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppRequestDialogModalInstalled = () => {
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: /*#__PURE__*/_jsx(SectionMessage, {
      appearance: "success",
      children: /*#__PURE__*/_jsx("p", {
        children: INSTALLED_STATE_CONTENT
      })
    })
  });
};